import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Outlet } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import { I18nProvider } from "@/i18n";
import { AuthProvider } from "@/context/AuthContext";
import { RefDataProvider } from "@/context/RefData";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { VerifyBanner } from "@/components/VerifyBanner";
import { RequireCustomer } from "@/components/RequireAuth";
import Home from "@/pages/Home";
import SearchPage from "@/pages/Search";
import ListingDetail from "@/pages/ListingDetail";
import RegisterPage from "@/pages/Register";
import AccountPage from "@/pages/account/Account";
import { LoginPage, ForgotPage, ResetPage, VerifyEmailPage, AuthCallback } from "@/pages/Auth";
import { LegalPage, HowPage } from "@/pages/Static";
import SellPage from "@/pages/Sell";
import PublicProfile from "@/pages/PublicProfile";
import { PaymentResult, PaymentCancelled } from "@/pages/PaymentResult";
import { ServiceResult } from "@/components/Services";
import { PromoPopup } from "@/components/PromoPopup";
import AdminApp, { ADMIN_BASE } from "@/admin/AdminApp";

const PublicLayout = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <VerifyBanner />
      <main className="flex-1"><Outlet /></main>
      <Footer />
      <PromoPopup />
    </div>
  );
};

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path={`${ADMIN_BASE}/*`} element={<AdminApp />} />
      <Route element={<PublicLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/cerca" element={<SearchPage />} />
        <Route path="/annuncio/:id" element={<ListingDetail />} />
        <Route path="/accedi" element={<LoginPage />} />
        <Route path="/registrati" element={<RegisterPage />} />
        <Route path="/password-dimenticata" element={<ForgotPage />} />
        <Route path="/reimposta-password" element={<ResetPage />} />
        <Route path="/verifica-email" element={<VerifyEmailPage />} />
        <Route path="/account" element={<RequireCustomer><AccountPage /></RequireCustomer>} />
        <Route path="/vendi" element={<RequireCustomer><SellPage /></RequireCustomer>} />
        <Route path="/utente/:id" element={<PublicProfile />} />
        <Route path="/pagamento/esito" element={<RequireCustomer><PaymentResult /></RequireCustomer>} />
        <Route path="/pagamento/servizio" element={<RequireCustomer><ServiceResult /></RequireCustomer>} />
        <Route path="/pagamento/annullato" element={<RequireCustomer><PaymentCancelled /></RequireCustomer>} />
        <Route path="/informative" element={<LegalPage />} />
        <Route path="/come-funziona" element={<HowPage />} />
        <Route path="*" element={<Home />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <RefDataProvider>
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </RefDataProvider>
      </AuthProvider>
    </I18nProvider>
  );
}
